import React from 'react';

export const SkipSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="16"
    height="11"
    viewBox="0 0 16 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.55349 0.946408C0.694506 0.453683 -0.00190353 0.85733 -0.00190353 1.84726V9.15249C-0.00190353 10.1434 0.694506 10.5465 1.55349 10.0543L7.93863 6.39244C8.79791 5.89954 8.79791 5.10097 7.93863 4.60818L1.55349 0.946408Z"
      fill="currentColor"
    />
    <path
      d="M8.97231 0.946408C8.11332 0.453683 7.41691 0.85733 7.41691 1.84726V9.15249C7.41691 10.1434 8.11332 10.5465 8.97231 10.0543L15.3574 6.39244C16.2167 5.89954 16.2167 5.10097 15.3574 4.60818L8.97231 0.946408Z"
      fill="currentColor"
    />
  </svg>
);

export default SkipSvg;
